import { ApolloClient, NormalizedCacheObject } from '@apollo/client'

import { getUserToken, getTokensPartner, getTokens, removeUserToken } from '.'
import { isExternalCompany } from './isExternalCompany'
import { ROUTES_PATH } from 'constants/routesPath'

export const getNewToken = async (client: ApolloClient<NormalizedCacheObject>) => {
    const userToken = await getUserToken()

    try {
        if (isExternalCompany()) {
            return await getTokensPartner(client, userToken)
        }

        return await getTokens(client, userToken)
    } catch (error) {
        await removeUserToken()
        window.history.pushState(null, '', ROUTES_PATH.NEW_SESSION_EXPIRED)
        return { accessToken: null, refreshToken: null }
    }
}
